<div class="app-header ui-g-1 ui-md-1 ui-lg-1 ui-g-nopad">
  <div class="top-bar-item">
    <button (click)="onSideMenuClick($event)"
      [attr.aria-label]="sidebarLabel?ariaLabelCloseSidebar:ariaLabelOpenSidebar" class="hamburger-menu">
      <i class="fa fa-bars"></i>
    </button>
  </div>
</div>
<div class="ui-g-11 ui-md-11 ui-lg-11 ui-g-nopad">

  <div class="nav-right-menu">
    <p-menubar [model]="items" [autoDisplay]="false">
    </p-menubar>
  </div>
</div>

<p-growl [value]="message"></p-growl>
<p-confirmDialog header="Confirmation" icon="fa fa-question-circle"></p-confirmDialog>